<div class="relative text-white tooltip leading-8 truncate cursor-default">
    <span class="truncate">
        {{ text }}
    </span>
    <!--<div
        class="invisible w-32 bg-slate-500 text-white text-center p-3 rounded-md absolute -bottom-full -left-1/2 tooltip__text">
        {{ tooltip }}
    </div>-->
</div>
